import { Box, Grid, Typography } from "@material-ui/core"
import React, { useCallback, useEffect, useRef } from "react"
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom"

import AccessBlockedPage from "@/pages/AccessBlockedPage"
import Admin from "@/pages/Admin"
import Agent from "@/pages/Admin/Agent"
import AdminAttendant from "@/pages/Admin/Attendant"
import Boards from "@/pages/Admin/Boards"
import ChatBotList from "@/pages/Admin/ChatBot/ChatBotList"
import AdminClientCatalogPage from "@/pages/Admin/ClientCatalog"
import ImportContacts from "@/pages/Admin/ClientCatalog/ImportContacts"
import Dashboard from "@/pages/Admin/Dashboard"
import FlowList from "@/pages/Admin/Flow/FlowList"
import ConfigureWebhook from "@/pages/Admin/Automation/Webhook/Configure"
import Group from "@/pages/Admin/Group"
import GroupMessageBlast from "@/pages/Admin/GroupMessageBlast"
import GroupMessageBlastManagement from "@/pages/Admin/GroupMessageBlast/Management"
import IndicationMember from "@/pages/Admin/IndicationMember"
import AdminIntegration from "@/pages/Admin/Integration"
import AdminIntegrationManagement from "@/pages/Admin/Integration/Management"
import MessageBlast from "@/pages/Admin/MessageBlast"
import MessageBlastManagement from "@/pages/Admin/MessageBlast/Management"
import Metrics from "@/pages/Admin/Metrics"
import Partnerships from "@/pages/Admin/Partnerships"
import Playground from "@/pages/Admin/Playground"
import ActiveCampaignPlugin from "@/pages/Admin/Plugins/ActiveCampaignPlugin"
import MetaAdsPlugin from "@/pages/Admin/Plugins/MetaAdsPlugin"
import RDStationPlugin from "@/pages/Admin/Plugins/RDStationPlugin"
import GoogleDrivePlugin from "@/pages/Admin/Plugins/GoogleDrivePlugin"
import SuperlogicaPlugin from "@/pages/Admin/Plugins/SuperlogicaPlugin"
import AdminQuickReplyPage from "@/pages/Admin/QuickReply"
import Reports from "@/pages/Admin/Reports"
import RedirectReport from "@/pages/Admin/Reports/components/RedirectReport"
import Security from "@/pages/Admin/Security"
import InboxChannelSettings from "@/pages/Admin/Settings/InboxChannel"
import AdminTag from "@/pages/Admin/Tag"
import AdminTeam from "@/pages/Admin/Team"
import RoleList from "@/pages/Admin/Role/RoleList"
import RoleDetails from "@/pages/Admin/Role/RoleDetails"
import Templates from "@/pages/Admin/Templates"
import ManageTemplateForm from "@/pages/Admin/Templates/ManageTemplateForm"
import TrackableLinks from "@/pages/Admin/TrackableLinks"
import CreateNewTrackableLink from "@/pages/Admin/TrackableLinks/CreateNewTrackableLink"
import EditTrackableLink from "@/pages/Admin/TrackableLinks/EditTrackableLink"
import TrackableLinkMetrics from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics"
import TrackableLinkMetricsV2 from "@/pages/Admin/TrackableLinks/TrackableLinkMetricsV2"
import WABAUsageStatement from "@/pages/Admin/WABAUsageStatement"
import Widgets from "@/pages/Admin/Widgets"
import WidgetEditor from "@/pages/Admin/Widgets/WidgetEditor"
import MeetingAnalyzerList from "@/pages/Admin/MeetingAnalyzer"
import MeetingAnalyzerDetail from "@/pages/Admin/MeetingAnalyzer/Detail"
import Attendance from "@/pages/Attendance"
import ChatPage from "@/pages/Attendance/Chat"
import InstanceChangedPage from "@/pages/InstanceChangedPage"
import IsTrialEndedPage from "@/pages/IsTrialEnded"
import OnboardingLetalkWizard from "@/pages/OnboardingLetalkWizard"
import SmartConversions from "@/pages/SmartConversions"
import legacyRoutesRedirects from "@/routes/LegacyRoutesRedirect"

import { Profile } from "@/components"
import CannyFeedback from "@/components/CannyFeedback"
import RedirectBot from "@/components/RedirectBot"
import Signature from "@/components/Signature"
import { openMerlinNonOwnerWarningDialog } from "@/components/MerlinNonOwnerWarning"

import AudioTest from "@/routes/private/components/AudioTest"
import UninassauFeatures from "@/routes/private/components/UninassauFeatures"

import { useGlobalStateStore } from "@/store/GlobalState"

import { usePermissionStateStore } from "@/store/PermissionState"
import HardCoded from "@/services/HardCoded"

import useStyles from "@/routes/styles"
import { isDevEnv } from "@/utils/environment"

export const AdminRoutes = () => (
	<Switch>
		{legacyRoutesRedirects}
		<Route
			exact
			path="/admin"
			render={() => <Redirect to={"/admin/dashboard"} />}
		/>
		<Route exact path="/admin/attendance/attendant" component={AdminAttendant} />
		<Route exact path="/admin/contacts/client-catalog" component={AdminClientCatalogPage} />
		<Route exact path="/admin/contacts/import-contacts" component={ImportContacts} />
		<Route exact path="/admin/groups" component={Group} />
		<Route exact path="/admin/attendance/quick-reply" component={AdminQuickReplyPage} />
		<Route exact path="/admin/attendance/teams" component={AdminTeam} />
		<Route exact path="/admin/attendance/roles/:roleId" component={RoleDetails} />
		<Route exact path="/admin/attendance/roles" component={RoleList} />
		<Route exact path="/admin/contacts/tags" component={AdminTag} />
		<Route exact path="/admin/metrics" component={Metrics} />
		<Route exact path="/admin/account/signature" component={Signature} />
		<Route exact path="/admin/account/profile" component={Profile} />
		<Route exact path="/admin/dashboard" component={Dashboard} />
		<Route exact path="/admin/reports" component={Reports} />
		<Route exact path="/admin/report/:reportType" component={RedirectReport} />
		<Route exact path="/admin/attendance/templates" component={Templates} />
		<Route exact path="/admin/attendance/widgets" component={Widgets} />
		<Route exact path="/admin/attendance/widgets/:widgetId" component={WidgetEditor} />
		<Route exact path="/admin/conversion/trackable-links/smart-conversions" component={SmartConversions} />
		<Route exact path="/admin/conversion/conversion-events/smart-conversions" component={SmartConversions} />
		<Route exact path="/admin/conversion/tools/trackable-links" component={TrackableLinks} />
		<Route exact path="/admin/conversion/tools/trackable-links/create" component={CreateNewTrackableLink} />
		<Route exact path="/admin/conversion/tools/trackable-links/:trackableLinkId/edit" component={EditTrackableLink} />
		<Route exact path="/admin/conversion/tools/trackable-links/:trackableLinkId/details" render={() => HardCoded.checkFeatureFlag("canViewTrackableLinkInteractionsFilters") ? <TrackableLinkMetricsV2 /> : <TrackableLinkMetrics />} />
		<Route exact path="/admin/template/manage" component={ManageTemplateForm} />
		{/* Unused route */}
		{/* <Route exact path="/admin/notifications" component={NotificationSettings} /> */}
		<Route exact path="/admin/automation/integration" component={AdminIntegration} />
		<Route exact path="/admin/automation/integration/:integrationId" component={AdminIntegrationManagement} />
		<Route exact path="/admin/plugins/active-campaign" component={ActiveCampaignPlugin} />
		<Route exact path="/admin/plugins/meta-ads" component={MetaAdsPlugin} />
		<Route exact path="/admin/plugins/rd-station" component={RDStationPlugin} />
		<Route
			exact
			path="/admin/plugins/rd-station-marketing"
			render={() => <Redirect to="/admin/plugins/rd-station" />}
		/>
		<Route
			exact
			path="/admin/plugins/rd-station-crm"
			render={() => <Redirect to="/admin/plugins/rd-station" />}
		/>
		<Route exact path="/admin/plugins/google-drive" component={GoogleDrivePlugin} />
		<Route exact path="/admin/plugins/superlogica" component={SuperlogicaPlugin} />
		<Route exact path="/admin/automation/message-blast" component={MessageBlast} />
		<Route exact path="/admin/automation/message-blast/:messageBlastId" component={MessageBlastManagement} />
		<Route exact path="/admin/group-message-blast" component={GroupMessageBlast} />
		<Route exact path="/admin/group-message-blast/:messageBlastId" component={GroupMessageBlastManagement} />
		<Route exact path="/admin/settings/inbox-channel/:inboxChannelId" component={InboxChannelSettings} />
		<Route exact path="/admin/waba/channel/:inboxChannelId/usage-statement" component={WABAUsageStatement} />
		<Route exact path="/admin/bots/:chatBotFlowId" component={RedirectBot} />
		<Route exact path="/admin/bots" component={ChatBotList} />
		<Route exact path="/admin/automation/flow/:chatBotFlowId" component={RedirectBot} />
		<Route exact path="/admin/automation/flow" component={FlowList} />
		<Route exact path="/admin/automation/webhook" component={ConfigureWebhook} />
		<Route exact path="/admin/audio-test" component={AudioTest} />
		<Route exact path="/admin/indication-member" component={IndicationMember}/>
		<Route exact path="/admin/feedback" component={CannyFeedback} />
		<Route exact path="/admin/account/security" component={Security} />
		<Route exact path="/admin/uninassau-features" component={UninassauFeatures} />
		<Route exact path="/admin/conversion/funnel" component={Boards} />
		<Route exact path="/admin/ai/playground" component={Playground} />
		<Route exact path="/admin/ai/agent" component={Agent} />
		<Route exact path="/admin/meeting-analyzer" component={MeetingAnalyzerList} />
		<Route exact path="/admin/meeting-analyzer/:meetingAnalysisId" component={MeetingAnalyzerDetail} />
		<Route exact path="/admin/ecosystem/partnerships" component={Partnerships} />
	</Switch>
)

export const AttendanceRoutes = () => (
	<Switch>
		<Route
			exact
			path="/attendance"
			render={() => <Redirect to={"/attendance/chat"} />}
		/>
		<Route exact path="/attendance/chat" component={ChatPage} />
	</Switch>
)

const PrivateRoutes = () => {
	const globalStateStore = useGlobalStateStore()
	const location = useLocation()
	const history = useHistory()
	const classes = useStyles()
	const { checkPermission } = usePermissionStateStore()

	const canAccessManagerPanel = checkPermission("manager-panel", "access")

	const userStore = globalStateStore.user

	const isAdminUser = userStore?.extra_data?.is_admin_mode

	const rawPagePathsMap: Record<string, JSX.Element> = {
		"/trial-ended": (
			<Switch>
				<Route path="/trial-ended" component={IsTrialEndedPage} />
			</Switch>
		),
		"/access-blocked": (
			<Switch>
				<Route path="/access-blocked" component={AccessBlockedPage} />
			</Switch>
		),
		"/onboarding-merlin": (
			<Switch>
				<Route path="/onboarding-merlin" component={OnboardingLetalkWizard} />
			</Switch>
		),
		"/instance-changed": (
			<Switch>
				<Route path="/instance-changed" component={InstanceChangedPage} />
			</Switch>
		)
	}
	const rawPagePaths = Object.keys(rawPagePathsMap)

	const checkIfIsTrialEnded = useCallback(() => {
		const {
			subscriptionData
		} = globalStateStore.instance

		const trialIsEnded = subscriptionData?.blockedReason === "trial-ended"

		if (location.pathname !== "/trial-ended" && trialIsEnded) {
			history.push("/trial-ended")
		}
	}, [globalStateStore.instance.subscriptionData?.blockedReason, location.pathname, history])

	const hasRedirectedToMerlin = useRef(false)
	const checkIfMerlinOnboardIsFinished = useCallback(() => {
		const isAlreadyOnMerlinPage = location.pathname === "/onboarding-merlin"

		const isTrialPlan = globalStateStore?.instance?.subscriptionData?.isTrial
		const willShow =
			globalStateStore?.instance?.merlinData?.willShow &&
			!isTrialPlan &&
			!isAdminUser &&
			!isDevEnv

		if (!hasRedirectedToMerlin.current && !isAlreadyOnMerlinPage && willShow) {
			hasRedirectedToMerlin.current = true
			history.push("/onboarding-merlin")
		}
	}, [globalStateStore.instance, globalStateStore.user, location.pathname, history])

	const hasShownMerlinNonOwnerWarning = useRef(false)
	const checkIfShouldShowMerlinNonOwnerWarning = useCallback(() => {
		const isInstanceOwner = globalStateStore?.user?.is_instance_owner
		const merlinStatus = globalStateStore?.instance?.merlinData?.status
		const instanceId = globalStateStore?.instance?.instance_id

		const shouldShowWarning =
			!isInstanceOwner &&
			merlinStatus === "pending" &&
			!hasShownMerlinNonOwnerWarning.current &&
			HardCoded.checkFeatureFlag("canShowMerlinNonOwnerWarning")

		if (!shouldShowWarning) {
			return
		}

		hasShownMerlinNonOwnerWarning.current = true

		openMerlinNonOwnerWarningDialog(instanceId)
	}, [globalStateStore.instance, globalStateStore.user])

	const checkIfIsAdmin = useCallback(() => {
		if (location.pathname.split("/")[1] === "admin") {
			if (!canAccessManagerPanel) {
				history.push("/attendance")
			}
		}
	}, [canAccessManagerPanel, location.pathname, history])

	const checkIfSubscriptionIsExpired = useCallback(() => {
		const subscriptionData = globalStateStore?.instance?.subscriptionData
		const isOnBlockedPage = location.pathname === "/access-blocked"

		const isSubscriptionExpired = subscriptionData?.blockedReason === "expired"

		const shouldBlockAccess = isSubscriptionExpired && !isOnBlockedPage
		const shouldRedirectToDashboard = !isSubscriptionExpired && isOnBlockedPage

		if (shouldBlockAccess) history.push("/access-blocked")
		if (shouldRedirectToDashboard) history.push("/admin/dashboard")
	}, [globalStateStore.instance.subscriptionData?.blockedReason, location.pathname, history])

	const matchedRawPagePath = rawPagePaths.find(path =>
		location.pathname.startsWith(path)
	)

	useEffect(() => {
		checkIfIsTrialEnded()
		checkIfIsAdmin()
		checkIfMerlinOnboardIsFinished()
		checkIfShouldShowMerlinNonOwnerWarning()
		checkIfSubscriptionIsExpired()
	}, [location.pathname, checkIfIsTrialEnded, checkIfIsAdmin, checkIfMerlinOnboardIsFinished, checkIfShouldShowMerlinNonOwnerWarning, checkIfSubscriptionIsExpired])

	return (
		<>
			{
				matchedRawPagePath
					? rawPagePathsMap[matchedRawPagePath]
					: (
						<>
							<Switch>
								<Route path="/admin" component={Admin} />
								<Route path="/attendance" component={Attendance} />
							</Switch>

							{
								isAdminUser &&
								<Box
									component="span"
									className={classes.isAdminMode}
								>
									<Grid
										container
										justifyContent="center"
										alignItems="center"
										style={{
											height: "100%"
										}}
									>
										<Grid item>
											<Typography
												variant="h2"
												align="center"
												color="inherit"
											>
												Modo administrador
											</Typography>
										</Grid>
									</Grid>

								</Box>
							}
						</>)
			}
		</>
	)
}

export default PrivateRoutes
